import {ChildEntity} from "typeorm";
import {Notification} from "@/modules/notifications/entity";
import {YouthPlayer} from "@/modules/youth/entity/YouthPlayer";
import {LocationAsRelativeRaw} from "vue-router";
import ScoutingCompletedNotificationComponent from "@/modules/youth/components/ScoutingCompletedNotification.vue";
import {Component} from "@vue/runtime-core";
import {ShallowRef} from "vue";

@ChildEntity()
export class ScoutingCompletedNotification extends Notification {
  setPayload(player: YouthPlayer) {
    this.payloadRaw = JSON.stringify({playerId: player.id, playerName: player.shortName});

    return this;
  }

  get payload(): { playerId: number, playerName: string } {
    return JSON.parse(this.payloadRaw!);
  }

  get to(): LocationAsRelativeRaw | undefined {
    return {name: 'youth.index'};
  }

  get component(): ShallowRef<Component> {
    return shallowRef(ScoutingCompletedNotificationComponent);
  }
}